import { GET_BOOKMARK } from "../../types";

const initialState = {
    loading: false, // Initit loading state
    bookmarkData: []
};

export default function(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case GET_BOOKMARK:
            return {
                ...state,
                bookmarkData: [...payload]
            };
        default:
            return state;
    }
}